var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.current_page < _vm.total_pages)?_c('button',{class:_vm.classes,on:{"click":function($event){return _vm.nextPage()}}},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a8d9598","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/themes/frontend/uikit3/assets/js/theme-components/grid/DataGridLoadMore.vue
// module id = 4/fj
// module chunks = 0